const configuredBase = import.meta.env?.VITE_API_BASE?.trim();

// Local Vite development proxies /api to the backend. Deployed builds retain the
// current production backend as a safe default when VITE_API_BASE is omitted.
export const API_BASE = (configuredBase || (import.meta.env?.DEV ? '' : 'https://api.recallcore.ai'))
  .replace(/\/+$/, '');

export function apiUrl(path) {
  const normalizedPath = path?.startsWith('/') ? path : `/${path || ''}`;
  if (!API_BASE) return normalizedPath;

  // Accept either an origin-style VITE_API_BASE or one already ending in /api.
  if (API_BASE.endsWith('/api') && normalizedPath.startsWith('/api/')) {
    return `${API_BASE}${normalizedPath.slice(4)}`;
  }

  return `${API_BASE}${normalizedPath}`;
}
